var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    fill: "#c5996f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 980 839.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406,83.71C190.35,115,64.9,210.79,23.08,376.19,10.23,426.65,10,431.55,10,657V866.07l6.31,11.68c7.47,14.48,24.06,30.14,38.78,36.91,11,5.14,12.15,5.14,164,5.14h153l13.08-6.07c16.12-7.71,29.67-20.79,37.38-36.21l5.61-11.45V555.37l-6.31-11.92c-3.5-6.54-11.68-16.82-18.22-22.66-19.39-17.52-22.67-18-108.17-18H220.71l1.4-23.13c2.1-30.6,11-64.48,23.6-90.17,28.5-57.47,84.8-91.11,165.63-98.35l18-1.63V184.86c0-57.7-.23-104.89-.47-104.66C428.4,80.43,418.12,81.84,406,83.71Z",
    transform: "translate(-10 -80.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M959.63,84.87q-296.8,44.51-367.71,261.88c-9.58,29.43-16.82,64.48-20.09,98.82-1.64,16.82-2.34,93.91-1.87,223.1l.7,197.4,5.61,11.45c7.71,15.42,21.26,28.5,37.38,36.21l13.08,6.07h153c152.31,0,153,0,164-5.14,15.42-7,32.94-24.29,39.48-38.78l5.61-12.15v-153c0-151.38,0-153-4.91-163.76-7-15-20.56-29.2-34.58-36.68L937.44,504l-78-1.16-78.26-1.17.7-15.18c1.4-36.21,13.31-81.06,28.5-107,4.44-7.24,16.82-22.19,27.8-33.17,16.59-16.59,23.59-22,42.05-30.84,25.7-12.62,50.93-19.62,85.5-23.36l24.3-2.8V184.63c0-57.47-.23-104.66-.47-104.42C989.06,80.2,975.75,82.3,959.63,84.87Z",
    transform: "translate(-10 -80.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuote);
export default __webpack_public_path__ + "static/media/quote.80e2227d9a535eef968bf1f2e868366c.svg";
export { ForwardRef as ReactComponent };